'use strict';

import './scripts/bootstrap.js';
import Vue from 'vue';
import App from './vue-components/about-teacher/App.vue';

new Vue({
  el: '#app',
  render (h) {
    return h(App);
  }
});



// WEBPACK FOOTER //
// ./client/app/about-teacher.js